$(document).ready(function() {
    if ($('.btn-set-user-data-from-request').length === 0) {
        return;
    }

    const lectureId = $('[data-lectureid]').first().data('lectureid');

    if (lectureId) {
        sendFacebookEvent('page-view', { lectureId: lectureId });
    }
});

let viewContentSent = false;
setTimeout(function() {
    if ($('.btn-set-user-data-from-request').length === 0) {
        return;
    }

    if (!viewContentSent) {
        const lectureId = $('[data-lectureid]').first().data('lectureid');
        if (lectureId) {
            viewContentSent = true;
            sendFacebookEvent('view-content', { lectureId: lectureId });
        }
    }
}, 10000);

$(document).on('click', '.btn-set-user-data-from-request', function (e) {
    const $btn = $(this);
    const lectureId = $btn.data('lectureid');

    if (!lectureId) {
        console.error('Lecture ID not found');
        return;
    }

    $.ajax({
        url: '/pixel-data/save',
        type: 'POST',
        data: {
            lectureId: lectureId,
        },
        success: function (response) {
            console.log('FB Pixel InitiateCheckout event sent:', response);
        },
        error: function (xhr, status, error) {
            console.error('Error sending InitiateCheckout event:', error);
        }
    });
});

function sendFacebookEvent(eventType, data) {
    const endpoints = {
        'page-view': '/pixel-data/page-view',
        'view-content': '/pixel-data/view-content',
        'add-payment-info': '/pixel-data/add-payment-info',
        'lead': '/pixel-data/lead'
    };

    const url = endpoints[eventType];

    if (!url) {
        console.error('Unknown Facebook event type:', eventType);
        return;
    }

    $.ajax({
        url: url,
        type: 'POST',
        data: data,
        success: function (response) {
            console.log(`Facebook ${eventType} event sent:`, response);
        },
        error: function (xhr, status, error) {
            console.error(`Error sending Facebook ${eventType} event:`, error);
        }
    });
}
